import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { LangProvider } from "./contexts/LangContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";

import { PublicLayout } from "./components/PublicLayout";
import { AdminLayout } from "./components/AdminLayout";
import RouteTracker from "./components/RouteTracker";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Klangschalen from "./pages/Klangschalen";
import Ernaehrung from "./pages/Ernaehrung";
import Vouchers from "./pages/Vouchers";
import VoucherSuccess from "./pages/VoucherSuccess";
import About from "./pages/About";
import Standort from "./pages/Standort";
import Booking from "./pages/Booking";
import Datenschutz from "./pages/Datenschutz";
import Impressum from "./pages/Impressum";
import AGB from "./pages/AGB";
import Stressabbau from "./pages/Stressabbau";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import TreatmentDetail from "./pages/TreatmentDetail";
import LocationPage from "./pages/LocationPage";
import DoshaTest from "./pages/DoshaTest";
import CookieBanner from "./components/CookieBanner";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminBookings from "./pages/admin/AdminBookings";
import AdminServices from "./pages/admin/AdminServices";
import AdminAvailability from "./pages/admin/AdminAvailability";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminCustomerDetail from "./pages/admin/AdminCustomerDetail";
import AdminFinances from "./pages/admin/AdminFinances";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminVouchers from "./pages/admin/AdminVouchers";
import AdminMessages from "./pages/admin/AdminMessages";
import AdminWaitlist from "./pages/admin/AdminWaitlist";
import AdminHeroImages from "./pages/admin/AdminHeroImages";

function App() {
  return (
    <ThemeProvider>
      <LangProvider>
        <AuthProvider>
        <div className="App">
          <Toaster position="top-right" richColors />
          <BrowserRouter>
            <RouteTracker />
            <CookieBanner />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/massagen" element={<Services />} />
                <Route path="/services" element={<Services />} />
                <Route path="/klangschalen" element={<Klangschalen />} />
                <Route path="/ernaehrung" element={<Ernaehrung />} />
                <Route path="/gutscheine" element={<Vouchers />} />
                <Route path="/gutscheine/erfolg" element={<VoucherSuccess />} />
                <Route path="/about" element={<About />} />
                <Route path="/standort" element={<Standort />} />
                <Route path="/contact" element={<Standort />} />
                <Route path="/booking" element={<Booking />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/agb" element={<AGB />} />
                {/* New SEO landing pages (Phase C + A) */}
                <Route path="/stressabbau" element={<Stressabbau />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                {/* SEO landing pages for treatments and locations */}
                <Route path="/behandlungen/:slug" element={<TreatmentDetail />} />
                <Route path="/standorte/:slug" element={<LocationPage />} />
                <Route path="/dosha-test" element={<DoshaTest />} />
                {/* 404 redirects (Phase D) — phantom URLs Rankly reported */}
                <Route path="/kur" element={<Navigate to="/massagen" replace />} />
                <Route path="/panchakarma" element={<Navigate to="/blog/panchakarma-verstehen" replace />} />
                <Route path="/dosha-test-old" element={<Navigate to="/dosha-test" replace />} />
                <Route path="/wochenende" element={<Navigate to="/gutscheine" replace />} />
                <Route path="/team" element={<Navigate to="/about" replace />} />
                <Route path="/massage" element={<Navigate to="/massagen" replace />} />
                <Route path="/abhyanga" element={<Navigate to="/behandlungen/abhyanga" replace />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="bookings" element={<AdminBookings />} />
                <Route path="services" element={<AdminServices />} />
                <Route path="availability" element={<AdminAvailability />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="customers/:id" element={<AdminCustomerDetail />} />
                <Route path="finances" element={<AdminFinances />} />
                <Route path="waitlist" element={<AdminWaitlist />} />
                <Route path="vouchers" element={<AdminVouchers />} />
                <Route path="messages" element={<AdminMessages />} />
                <Route path="hero-images" element={<AdminHeroImages />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </LangProvider>
   </ThemeProvider>
  );
}

export default App;
